import React from 'react';
import classNames from 'classnames';
import { StoryObject } from '@benzinga/advanced-news-manager';
import { BzImage } from '@benzinga/image';
import { ArticleData } from '@benzinga/article-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { formatImageUrl } from '@benzinga/utils';
import styles from './RelatedArticles.module.scss';

export interface RelatedArticlesProps {
  className?: string;
  excludedArticles?: number[];
  nodes: ArticleData[];
  // queryBy?: 'Channels' | 'Tickers' | 'Tags';
  includeImages?: boolean;
  pageCount?: number;
  viewMoreLink?: string;
}

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({
  className = '',
  excludedArticles,
  includeImages = true,
  nodes,
  pageCount = 5,
  viewMoreLink,
}) => {
  let filteredNodes = excludedArticles
    ? nodes.filter(node => node.nodeId && !excludedArticles.includes(node.nodeId))
    : nodes;
  if (!filteredNodes.length) return <></>;
  if (filteredNodes.length > pageCount) {
    filteredNodes = filteredNodes.slice(0, pageCount);
  }

  return (
    <div className={classNames(styles.container, 'top-stories', className)}>
      <div className="header-container">
        <h2>Trending Articles</h2>
      </div>
      <div className="stories-list">
        {filteredNodes.map((node: ArticleData, index: number) => {
          const image = formatImageUrl(node as unknown as StoryObject);
          return (
            <div className="stories-list-item" key={index}>
              <div>
                <a
                  className="story-link"
                  data-action="Clicked Related Article"
                  href={`/${node.canonicalPath}`}
                  rel="noreferrer"
                >
                  {image && includeImages && (
                    <div className={styles.imageWrapper}>
                      <BzImage alt="" height={70} layout="fixed" objectFit="cover" src={image} width={70} />
                    </div>
                  )}
                  <div>
                    <h3 className="story-title">{node.title}</h3>
                    <div className={styles.storySubtitle}>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHTML(node.metaProps?.description ?? node.teaserText),
                        }}
                      />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          );
        })}
      </div>
      {viewMoreLink && (
        <a href={viewMoreLink} style={{ marginTop: '5px' }}>
          View more
        </a>
      )}
    </div>
  );
};

export default RelatedArticles;
